/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-28 10:37:01
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-09-02 21:45:46
 * @FilePath: \mpc-3\features\mpc-common\src\components\BackModal\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import globalLoading from "#components/globalLoading";
import ModalTriggerWrapper from "#components/ModalTriggerWrapper";
import { Alert, Form, Input, Modal } from "@bedrock/components"
import React from "react"

const BackModal = (props) => {
  const { warningMessage, reasonMaxLength = 200, ...rest } = props;

  const [form] = Form.useForm();

  const handleOk = async () => {
    globalLoading.show();
    const data = await form.validateFields();
    try {
      await props.onOk(data);
    } catch (error) {
      console.log(error);
    }
    globalLoading.done();
  }

  return (
    <Modal
      destroyOnClose
      maskClosable={false}
      title="退回"
      width={480}
      {...rest}
      onOk={handleOk}
    >
      {warningMessage && <Alert style={{ marginBottom: 20 }} type="warning" message={warningMessage} className="flex-1" />}
      <Form form={form} showLabelColon layout='vertical'>
        <Form.Item rules={[{ required: true, message: '请输入退回原因' }]} label="退回原因" name="reason">
          <Input.TextArea showCount maxLength={reasonMaxLength} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

BackModal.Trigger = ModalTriggerWrapper(BackModal);

export default BackModal;